import { MantineProvider, createTheme } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import type { ReactNode } from 'react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // не ретраить на 4xx
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
  },
})

// Ledokol brand: deep blue из ТЗ §2.2
const theme = createTheme({
  primaryColor: 'blue',
  primaryShade: 8,
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  defaultRadius: 'md',
  colors: {
    blue: [
      '#eef4fa',
      '#d4e3f1',
      '#a8c6e3',
      '#7ba9d5',
      '#5e94ca',
      '#4e87c2',
      '#4480c0',
      '#346eaa',
      '#2E75B6',
      '#1F4E79',
    ],
  },
})

export function Providers({ children }: { children: ReactNode }) {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-right" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>{children}</BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  )
}
